import * as React from 'react';
import { StoreContext } from '../../utils';
import { SigninButtonGoogle } from '../../auth/SigninButtonGoogle';
import { SigninButtonFacebook } from '../../auth/SigninButtonFacebook';
import { SignInButtonApple } from '../../auth/SignInButtonApple';
import { PortalLoginButtonAuth0 } from '../../auth/PortalLoginButtonAuth0';
import { Store } from '../../store/Store';
import { PortalRegisterButtonGoogle } from '../../auth/PortalRegisterButtonGoogle';

export class LehrerWelcomeAnonym extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  get accordeon() {
    return (
      <div className="col-lg-5">
        <div className="embed-responsive embed-responsive-16by9" style={{ marginBottom: 20, borderRadius: 10 }}>
          <video controls className="embed-responsive-item" style={{ borderRadius: 6 }}>
            <source src="https://dev.schlaukopf.de/static/vid/lehrerbereich.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="accordion accordion-solid accordion-panel accordion-svg-toggle" id="accordionExample8">
          <div className="card">
            <div className="card-header" id="headingOne8">
              <div className="card-title collapsed" data-toggle="collapse" data-target="#collapseOne8" aria-expanded="false">
                <div className="card-label">Was ist der Schlaukopf Lehrerbereich?</div>
                <span className="svg-icon">
                  {/*begin::Svg Icon | path:assets/media/svg/icons/Navigation/Angle-double-right.svg*/}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                        fill="#000000"
                        fillRule="nonzero"
                      />
                      <path
                        d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                        fill="#000000"
                        fillRule="nonzero"
                        opacity="0.3"
                        transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999)"
                      />
                    </g>
                  </svg>
                  {/*end::Svg Icon*/}
                </span>
              </div>
            </div>
            <div id="collapseOne8" className="collapse" data-parent="#accordionExample8" style={{}}>
              <div className="card-body">
                Der Schlaukopf Lehrerbereich ergänzt die Schlaukopf Lernplattform um <b>Funktionen für Lehrer</b>.<br />
                Sie können beispielsweise Arbeitsaufträge / Hausaufgaben an ihre Klasse erteilen und die Statistiken davon einsehen. <br />
                In den nächsten Monaten werden weitere Funktionen hinzukommen.
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="headingTwo8">
              <div className="card-title collapsed" data-toggle="collapse" data-target="#collapseTwo8" aria-expanded="false">
                <div className="card-label">Entstehen Kosten oder Verpflichtungen?</div>
                <span className="svg-icon">
                  {/*begin::Svg Icon | path:assets/media/svg/icons/Navigation/Angle-double-right.svg*/}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                        fill="#000000"
                        fillRule="nonzero"
                      />
                      <path
                        d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                        fill="#000000"
                        fillRule="nonzero"
                        opacity="0.3"
                        transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999)"
                      />
                    </g>
                  </svg>
                  {/*end::Svg Icon*/}
                </span>
              </div>
            </div>
            <div id="collapseTwo8" className="collapse" data-parent="#accordionExample8" style={{}}>
              <div className="card-body">
                Der Schlaukopf Lehrerbereich ist <b>kostenlos</b>. Es entstehen keine Verpflichtungen.
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="headingThree8">
              <div className="card-title collapsed" data-toggle="collapse" data-target="#collapseThree8">
                <div className="card-label">Ist der Schutz der Daten gewährleistet?</div>
                <span className="svg-icon">
                  {/*begin::Svg Icon | path:assets/media/svg/icons/Navigation/Angle-double-right.svg*/}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                        fill="#000000"
                        fillRule="nonzero"
                      />
                      <path
                        d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                        fill="#000000"
                        fillRule="nonzero"
                        opacity="0.3"
                        transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999)"
                      />
                    </g>
                  </svg>
                  {/*end::Svg Icon*/}
                </span>
              </div>
            </div>
            <div id="collapseThree8" className="collapse" data-parent="#accordionExample8">
              <div className="card-body">
                Selbstverständlich. Wir speichern so wenig Daten wie möglich und tun unser bestes, um die Sicherheit der Daten zu
                gewährleisten. Weitere Informationen erhalten Sie in unserer <a href="/info/datenschutz">Datenschutzerklärung</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { gruppe, gruppenmitglieder, portalStore, vorgaben } = this.context.lehrerStore;

    return (
      <div className="row">
        <div className="col-xl-7">
          {/*begin::Engage Widget 11*/}
          <div className="card card-custom card-stretch gutter-b">
            <div className="card-body d-flex p-0">
              <div
                className="flex-grow-1 p-20 pb-40 card-rounded flex-grow-1 bgi-no-repeat"
                style={{
                  minHeight: 800,
                  backgroundPosition: 'calc(100% + 0.5rem) bottom',
                  backgroundSize: '35% auto',
                  backgroundImage: 'url(/static/img/lehrer/welcome.png)',
                }}
              >
                <h2 className="text-dark pb-5 font-weight-bolder">Willkommen im Schlaukopf Lehrerbereich!</h2>
                <p className="text-dark-50 pb-5 font-size-h5">
                  Verbinden Sie sich mit einem Login-Provider, um den Lehrerbereich zu verwenden.
                </p>
                <iframe
                  id="browsermodal"
                  src="/auth/signin?inline=1"
                  style={{ width: '100%', height: 600, border: 'none', display: 'block' }}
                />
              </div>
            </div>
          </div>
          {/*end::Engage Widget 11*/}
        </div>
        {this.accordeon}
      </div>
    );
  }
}
